<template lang="html">
  <div>
    <label>{{label}}{{this.required !== undefined ? '*' : ''}}</label>
    <v-text-field
      :rows="2"
      :auto-grow="true"
      multi-line
      :counter="counter"
      :rules="couterRules"
      :required="required"
      :value="value"
      @input="setTexto"
    >
    </v-text-field>
  </div>
</template>

<script>
  export default {
    props: ['label', 'value', 'counter', 'rules', 'clearable', 'required'],
    data: () => ({
      focus: false
    }),
    computed: {
      couterRules: function (val) {
        let area = [
          (input) => (this.required === undefined) || !!input || 'Este campo é obrigatório',
          (input) => (input == null || input.length <= this.counter) || 'Este campo não pode possuir mais que ' + this.counter + ' caracteres'
        ]
        return area
      }
    },
    methods: {
      setTexto (value) {
        this.$emit('input', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// c-solo-text-field.vue?f0eefef4